export const insertAt = <T>(array: T[], index: number, ...elementsArray: T[]): T[] => {
    const copiedArr = [...array]
    copiedArr.splice(index, 0, ...elementsArray);
    return copiedArr
}